import {Tooltip} from 'platform/components';
import {Heading, HStack, Icon, Text, ThemeIconKey, VStack} from 'platform/foundation';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {AvatarIcon} from '../../../components/AvatarIcon/AvatarIcon';

interface ElectricalItemProps extends TestIdProps {
  value: string | number;
  categoryTitle: string;
  icon: ThemeIconKey;
  labelTooltip?: string | Nullish;
}

export function ElectricalItem(props: ElectricalItemProps) {
  const valueIsNotEmptyString = props.value !== '';
  return (
    <HStack spacing={4} align="center">
      <AvatarIcon icon={props.icon} />
      <VStack spacing={props.categoryTitle && valueIsNotEmptyString ? 1 : 0}>
        <HStack spacing={1}>
          <Text data-testid={suffixTestId('category', props)} size="xSmall" color="secondary">
            {props.categoryTitle}
          </Text>
          {props.labelTooltip && (
            <Tooltip label={props.labelTooltip}>
              <Icon value="action/info" size={4} color="text.tertiary" />
            </Tooltip>
          )}
        </HStack>
        <Heading data-testid={suffixTestId('value', props)} size={4}>
          {String(props.value)}
        </Heading>
      </VStack>
    </HStack>
  );
}
